import React, { Component } from "react";
import { LinkButton } from "components/ui/MasterButton";

class NoResults extends Component {
  render() {
    return (
      <div className="padding-sides padding-bottom center-content desktop-and-tablet">
        <div
          style={{
            marginTop: 46,
            marginBottom: 157,
            fontSize: 16,
            fontWeight: 600
          }}
        >
          Search for a course or{" "}
          <LinkButton text="view all courses" link="course-areas/all-courses" />
        </div>
      </div>
    );
  }
}

export default NoResults;
